/**
 * For ADSK domains - noopener only. For non-ADSK domains - add noreferrer.
 * @param url
 * @return {string}
 */
export default (url: string): string =>
  'noopener' +
  (/(?:\.|^)autodesk\.(?:com|eu)(?::\d+)?$/.test(
    new URL(url, window.location.origin).hostname,
  )
    ? ''
    : ' noreferrer');
